import React, { useEffect, useRef } from "react";
import { ICellEditorParams } from '@ag-grid-community/core';

import { DatePicker } from "../ui/DatePicker";

import './InputDatetimeCellEditor.css';

const InputDatetimeCellEditor = (props: ICellEditorParams) => {

    const countRef = useRef<Date|null>(props.value ? new Date(props.value) : null);

    const setGridValue = (date: Date | null) => {
      let value:String = "";
      if (date) {
        const year = date.getFullYear();
        const month = ("0" + (date.getMonth() + 1)).slice(-2); // 月は0から始まるため、1を加える
        const day = ("0" + date.getDate()).slice(-2);
        const hours = ("0" + date.getHours()).slice(-2);
        const minutes = ("0" + date.getMinutes()).slice(-2);
        const seconds = ("0" + date.getSeconds()).slice(-2);
        value = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
      }
      if (props.colDef?.field) {
        props.node.setDataValue(props.colDef.field, value);
      }
    }

    const onChangeDate = (date: Date | null) => {
      if (date) {
        countRef.current = date;
      } else {
        // すべて削除したら変更前に戻す
        countRef.current = props.value ? new Date(props.value) : null
      }
    };

    const onSelectDate = (date: Date | null) => {
      countRef.current = date;
      setGridValue(date);
      props.api.stopEditing();
    }

    const onCalendarClose = () => {
      setGridValue(countRef.current);
      props.api.stopEditing();
    }

    const onBlur = (e: React.FocusEvent<HTMLInputElement>) => {
      let date: Date | null = null;
      if (e.target.value) {
        try {
          const now = new Date();
          date = new Date(now.getFullYear().toString().slice(0, 2) + e.target.value);
        } catch (e) {
          console.error(e);
        }
      }
      countRef.current = date;
      setGridValue(date);
    };

    useEffect(() => {
      if (props.cellStartedEdit) {
        // セルが編集モードに入ったときの処理
        props.eGridCell?.querySelector("input")?.focus();
      }
    }, [props.cellStartedEdit]);

    useEffect(() => {
      return () => {
        // コンポーネントがマウントされたときに実行される処理   
        setGridValue(countRef.current);
      };
    }, []);

    return (
      <div className="grid_datetime_input">
        <DatePicker 
          selected={props.value ? new Date(props.value) : null}
          onChange={onChangeDate}
          onSelect={onSelectDate}
          onCalendarClose={onCalendarClose}
          onBlur={onBlur}
          showTimeSelect
          timeFormat="HH:mm"
          dateFormat="yy/MM/dd HH:mm:ss"
          calendarStartDay={1}
          timeIntervals={10}
          timeCaption="時間"
          portalId="root-portal"
        />
      </div>
    );
  };

export default InputDatetimeCellEditor;
